export default "__VITE_ASSET__Zuo0gnJ8__"